import React from 'react';
import {Link} from "react-router-dom";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state to show fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Log the error to an error reporting service.
    console.error("Error caught by ErrorBoundary:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return <div className="text-center py-10">
        <h1 className="text-3xl font-semibold">Something went wrong!</h1>
        <p className="pt-4 pb-2">If you see this please report it to the BUIHA Tech Team</p>
        <Link to="/" className="mt-8 text-blue-500 hover:underline">Let's go back home</Link>
      </div>;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;